import { TFunction } from "@impero-com/common/utils/i18n";

import { SelectOptionType } from "components/form/formAtomFields/faSelectMultipleInput";

export function generateReminderDayOptions(
    t: TFunction
): SelectOptionType<number> {
    return Array.from(new Array(365), (_v, idx) => {
        return {
            value: idx + 1,
            label: `${idx + 1} ${t("Controls_Schedule_Day", {
                count: idx + 1,
            })}`,
        };
    });
}

export function sortRemindersAscending(
    reminders: (string | number)[]
): (string | number)[] {
    return reminders.toSorted((a, b) => Number(a) - Number(b));
}

export function sortRemindersDescending(
    reminders: (string | number)[]
): (string | number)[] {
    return reminders.toSorted((a, b) => Number(b) - Number(a));
}
